import React from 'react';
import {
  CheckCircleFilled,
  ClockCircleOutlined,
  CloseCircleFilled,
  ExclamationCircleFilled,
  MinusCircleOutlined,
  QuestionCircleOutlined,
  StopOutlined,
  SyncOutlined,
  WarningFilled,
} from '@ant-design/icons';
import { DeliveryOutcome, DeliveryOutcomeGroup } from '../../../domain/entities/DeliveryDashboard';

export const GROUP_COLORS: Record<DeliveryOutcomeGroup, string> = {
  done: '#0ca30c',
  problem: '#d03b3b',
  attention: '#fab219',
  pending: '#b8c0cc',
  other: '#dde1e6',
};

export const OUTCOME_TAG_COLORS: Record<DeliveryOutcome, string> = {
  sent: 'success',
  failed: 'error',
  rejected: 'error',
  skipped: 'default',
  retrying: 'warning',
  delayed: 'warning',
  running: 'processing',
  planned: 'default',
  cancelled: 'default',
  unknown: 'default',
};

export const OUTCOME_ICONS: Record<DeliveryOutcome, React.ReactNode> = {
  sent: <CheckCircleFilled />,
  failed: <CloseCircleFilled />,
  rejected: <StopOutlined />,
  skipped: <MinusCircleOutlined />,
  retrying: <ExclamationCircleFilled />,
  delayed: <WarningFilled />,
  running: <SyncOutlined spin />,
  planned: <ClockCircleOutlined />,
  cancelled: <MinusCircleOutlined />,
  unknown: <QuestionCircleOutlined />,
};
